import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { sendPasswordResetEmail } from 'firebase/auth';
import { auth } from '../firebase';
import CircularProgress from '@mui/material/CircularProgress';
import { Box, TextField, Button, Paper, Typography, Alert, Link as MuiLink } from '@mui/material';
import { useLoading } from '../contexts/LoadingContext'; // Updated to use the correct LoadingContext hook

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { isLoading, setLoading } = useLoading(); // Use the updated loading context

  // Handle password reset submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    setError('');
    setLoading(true, 'ForgotPassword'); // Manage global loading state

    try {
    const actionCodeSettings = {
      url: 'https://app.utmsmartmanager.com/login',
      handleCodeInApp: false,
    };

    await sendPasswordResetEmail(auth, email, actionCodeSettings);

      setMessage('A password reset link has been sent to your email. Please check your inbox.');
    } catch (error) {
      console.error('Reset Password Error:', error);
      setError(error?.message || 'Failed to reset password. Please try again.');
    } finally {
      setLoading(false, 'ForgotPassword'); // Reset the global loading state
    }
  };

  return (
    <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
      <Paper elevation={3} sx={{ padding: 4, maxWidth: 400, width: '100%', textAlign: 'center', m: 3 }}>
        <Typography variant="h5" sx={{ marginBottom: 2 }}>Reset Password</Typography>
        <Typography variant="body1" sx={{ marginBottom: 2 }}>
          Enter your email address below, and we'll send you a link to reset your password.
        </Typography>
        {error && <Alert severity="error" sx={{ marginBottom: 2 }}>{error}</Alert>}
        {message && <Alert severity="success" sx={{ marginBottom: 2 }}>{message}</Alert>}
        <form onSubmit={handleSubmit}>
          <TextField 
            label="Email" 
            type="email" 
            required 
            fullWidth 
            margin="normal"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            disabled={isLoading}
          />
          <Button 
            type="submit" 
            variant="contained" 
            color="primary" 
            sx={{ marginTop: 2, width: '75%' }}
            disabled={isLoading}
          >
            {isLoading ? <CircularProgress size={24} /> : 'Send Reset Link'}
          </Button>
        </form>
        <Typography variant="body2" sx={{ mt: 2 }}>
          Remembered your password? 
          <MuiLink 
            component="button"
            onClick={() => navigate('/login')} // Align with Index2.js routing (Login page)
            sx={{ ml: 1, textDecoration: 'none' }}
          >
            Back to Login
          </MuiLink>
        </Typography>
      </Paper>
    </Box>
  );
}

export default ForgotPassword;
